import React, { useState, useEffect } from "react";
import { Row, Col, Space, Typography, Select, Upload, Spin } from "antd";
import AddPhysicianModalWrapper from "../../../modal/AddPhysicianModalWrapper";
import {
  CustomButton,
  CustomSecondaryButton,
} from "../../physician_page/styled";
import { physicianService } from "../../../../services/user";
import script from "../../../../services/script";
import { notify } from "../../../../utils/helper";
import { CloudUploadOutlined } from "@ant-design/icons";
import recording from "../../../../services/recording";
import { FileUploadContainer, SpinWrapper } from "../../myprofile/MyProfilePage";

const { Text } = Typography;
const { Dragger } = Upload;
const { Option } = Select;

const UploadModal = ({ isOpen, setOpen, fetchScript }) => {
  const [loading, setLoading] = useState(false);
  const [physicians, setPhysicians] = useState([]);
  const [allScript, setAllScript] = useState([]);
  const [selectedPhysicianId, setSelectedPhysicianId] = useState(null);
  const [selectedScriptId, setSelectedScriptId] = useState(null);
  const [file, setFile] = useState(null);

  const handleUpload = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("name", file.name);
      formData.append("file", file);
      formData.append("script", selectedScriptId);
      formData.append("userId", selectedPhysicianId);
      const res = await recording.saveRecording(formData);
      if (res?.status === 201) {
        notify("success", "Uploaded successfully!");
        fetchScript();
        setOpen(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchPhysicians = async () => {
    if (!isOpen) return;
    setLoading(true);
    try {
      const res = await physicianService.getAll(0, 1, "", "", "");
      setPhysicians(res?.data?.results);
    } catch (error) {
      notify("error", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllScript = async () => {
    if (!isOpen) return;
    setLoading(true);
    try {
      const res = await script.getScripts(0, 1, "", "", "");
      setAllScript(res?.data?.results);
    } catch (error) {
      notify("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPhysicians();
    fetchAllScript();
  }, [isOpen]);



  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <AddPhysicianModalWrapper
      title={
        <div className="row-flex flex-column">
          <h3 className="font-18 font-semibold text-primary mb-5">
            Upload Audio For Script
          </h3>
        </div>
      }
      open={isOpen}
      setShow={handleCancel}
      width={600}
      footer={null}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="large">
        <div>
          <Text strong style={{ marginBottom: "8px", display: "block", color: "var(--primary-text-color)" }}>
            Select a Script:
          </Text>
          <Select
            placeholder="Select a script"
            showSearch
            style={{ width: "100%" }}
            // options={getScriptOptions()}
            value={selectedScriptId}
            onChange={setSelectedScriptId}
            loading={loading}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {allScript.map((script) => (
              <Option
                key={script.id}
                label={script.scriptTitle}
                value={script.id}
                style={{borderBottom: "1px solid var(--border-color)"}}
              >
                {script.scriptTitle}
              </Option>
            ))}
           
          </Select>
        </div>

        <div>
          <Text strong style={{ marginBottom: "8px", display: "block", color: "var(--primary-text-color)" }}>
            Select a physician:
          </Text>
          <Select
            placeholder="Select a physician"
            showSearch
            style={{ width: "100%" }}
            // options={getPhysicianOptions()}
            value={selectedPhysicianId}
            onChange={setSelectedPhysicianId}
            loading={loading}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {physicians.map((physician) => (
              <Option
                key={physician.id}
                label={`${physician.name} : ${physician?.specialty} - ${physician?.email}`}
                value={physician.id}
                style={{borderBottom: "1px solid var(--border-color)"}}
              >
                {physician.name} : {physician?.specialty} - {physician?.email}
              </Option>
            ))}
          </Select>
        </div>

        <div>
          <Text strong style={{ marginBottom: "8px", display: "block", color: "var(--primary-text-color)" }}>
            Upload audio file:
          </Text>
          <FileUploadContainer>

         
          <Dragger
            name="file"
            multiple={false}
            accept=".mp3, .wav, .m4a, .ogg, .aac, .mp4"
            beforeUpload={() => false}
            disabled={loading}
            onChange={(info) => {
              setFile(info.file);
            }}
            maxCount={1}
          >
            <p className="ant-upload-drag-icon" style={{ color: "var(--primary-text-color)" }}>
              <CloudUploadOutlined style={{ color: "#" }} />
            </p>
            <p className="ant-upload-text" style={{ color: "var(--primary-text-color)" }}>
              Click or drag audio file to this area to upload
            </p>
            <p className="upload-hint">
              Supports: MP4, MP3, WAV, M4A, OGG, AAC formats
            </p>
          </Dragger>
          </FileUploadContainer>
        </div>
      </Space>

     <SpinWrapper>
      <Col span={24} className="d-flex justify-end gap-12 mt-20">
        <CustomSecondaryButton key="cancel" onClick={handleCancel}>
          Cancel
        </CustomSecondaryButton>
        <CustomButton
          key="upload"
          type="primary"
          disabled={!selectedPhysicianId || !selectedScriptId || !file}
          onClick={handleUpload}
        >
          {loading ? "Uploading..." : "Upload Audio"}
          <Spin spinning={loading} className="d-flex justify-content-center ml-5" size="small" />
        </CustomButton>
      </Col>
      </SpinWrapper>
    </AddPhysicianModalWrapper>
  );
};

export default UploadModal;
